import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { DealerPartNumberResultsRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { TireSearchResultsPayload } from "./useSearchTiresByVehicle";

export const useSearchTiresByPartNumber = (
  swrOptions: SWRConfiguration<FetcherResult<TireSearchResultsPayload>> = {}
): ModifiedSWRResponse<
  FetcherResult<TireSearchResultsPayload>,
  TireSearchResultsPayload
> => {
  const route = useRouteParams(DealerPartNumberResultsRoute);

  const { data, ...result } = useSwrGet<TireSearchResultsPayload>(
    route
      ? "/retailSiteWebService/parts/tire/searchTiresByPartNumber.php"
      : null,
    {
      dealerId: route?.dealerId || "",
      partNumber: route?.partNumber || "",
    },
    swrOptions
  );

  return { ...result, data };
};
